<template>
  <div>
    <!-- 展示个人信息 -->
    <template v-if="type === 1">
      <div class="se-flex aic jcsb">
        <div class="ft-22-333">个人信息</div>
        <div
          v-if="user.accountType === 0"
          class="se-flex aic cp"
          @click="userAction"
        >
          <img
            src="../../../assets/icons/edit.png"
            style="width: 23px; height: 23px"
          />
          <div class="ft-18-red se-m-l-10">编辑</div>
        </div>
      </div>
      <div>
        <el-form
          ref="form"
          :model="form"
          label-width="80px"
          label-position="left"
          style="width: 50%; margin-top: 35px"
        >
          <el-form-item label="头像">
            <el-avatar
              :size="63"
              :src="user.avatar || require('../../../assets/images/logo2.png')"
            ></el-avatar>
          </el-form-item>
          <el-form-item label="姓名">
            <div class="ft-14-666">
              {{ user && user.persionName ? user.persionName : "--" }}
            </div>
          </el-form-item>
          <el-form-item label="职位">
            <div class="ft-14-666">
              {{ user && user.position ? user.position : "--" }}
            </div>
          </el-form-item>
          <el-form-item label="所在部门">
            <div class="ft-14-666">
              {{ user && user.dept ? user.dept.deptName : "--" }}
            </div>
          </el-form-item>
          <el-form-item label="所在单位">
            <div class="ft-14-666">
              {{ user && user.companyName ? user.companyName : "--" }}
            </div>
          </el-form-item>
          <!-- <el-form-item label="身份证号">
            <div class="se-flex aic">
              <div class="ft-14-666 se-m-r-20">
                {{ (flag1 ? user.encryptIdCard : user.idCard) || "--" }}
              </div>
              <img
                v-show="flag1 === true"
                src="../../../assets/icons/eye1.png"
                style="width: 22px; height: 8px; cursor: pointer"
                @click="flag1 = !flag1"
              />
              <img
                v-show="flag1 === false"
                src="../../../assets/icons/eye2.png"
                style="width: 24px; height: 16px; cursor: pointer"
                @click="flag1 = !flag1"
              />
            </div>
          </el-form-item> -->
          <el-form-item label="手机号">
            <div class="se-flex aic">
              <div class="ft-14-666 se-m-r-20">
                {{
                  (flag2 ? user.encryptPhonenumber : user.phonenumber) || "--"
                }}
              </div>
              <img
                v-show="flag2 === true"
                src="../../../assets/icons/eye1.png"
                style="width: 22px; height: 8px; cursor: pointer"
                @click="flag2 = !flag2"
              />
              <img
                v-show="flag2 === false"
                src="../../../assets/icons/eye2.png"
                style="width: 24px; height: 16px; cursor: pointer"
                @click="flag2 = !flag2"
              />
            </div>
          </el-form-item>
          <el-form-item label="讲师类型">
            <div class="ft-14-666" v-if="user.teacherType === 1">内部讲师</div>
            <div class="ft-14-666" v-else>外部讲师</div>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <!-- 编辑个人信息 -->
    <template v-if="type === 2">
      <div class="ft-22-333">个人信息</div>
      <el-form
        ref="form"
        :rules="rules"
        :model="formA"
        label-width="80px"
        label-position="left"
        style="width: 50%; margin-top: 30px"
      >
        <el-form-item label="头像">
          <div class="se-flex">
            <el-avatar
              :size="63"
              :src="avaUrl || require('../../../assets/images/logo2.png')"
              class="se-m-r-15"
            ></el-avatar>
            <!-- :show-file-list="false" -->
            <!-- :limit="1" -->
            <el-upload
              name="file"
              accept="image/*"
              class="avatar-uploader"
              :action="`${baseURL}server/common/upload`"
              :headers="headers"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="persionName"
            :disabled="userInfo.accountType == 1"
          ></el-input>
        </el-form-item>
        <el-form-item label="职位">
          <el-input
            v-model.trim="userInfo.position"
            :maxlength="10"
            @input="inputLimit"
            :disabled="positionDisabled"
          ></el-input>
          <!-- userInfo.accountType == 1 && userInfo.position -->
        </el-form-item>
        <!-- 自主注册 -->
        <template>
          <el-form-item label="所在部门">
            <el-input
              v-model="userInfo.dept.deptName"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="所在单位">
            <el-input
              v-model="userInfo.companyName"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </template>

        <!-- 自主注册以下可修改 -->

        <!-- <el-form-item
          label="身份证号"
          :rules="[
            { min: 18, max: 18, message: '长度在18位', trigger: 'blur' },
          ]"
        >
          <el-input
            v-model="userInfo.idCard"
            :maxlength="18"
            :minlength="18"
            :disabled="userInfo.accountType == 1"
          ></el-input>
        </el-form-item> -->

        <el-form-item label="手机号">
          <div class="ft-14-666 se-m-r-20">
            {{ userInfo.phonenumber }}
          </div>
        </el-form-item>

        <el-form-item label="讲师类型">
          <el-select
            v-model="userInfo.teacherType"
            placeholder="请选择"
            clearable
            style="width: 100%"
            disabled
          >
            <el-option
              v-for="item in teacherTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button class="se-m-r-20 se-m-t-20" @click="onBack">取消</el-button>
      <el-button type="danger" class="se-m-t-20" @click="editUserInfo"
        >保存</el-button
      >
    </template>
  </div>
</template>

<script>
import { baseURL } from "@/utils/request";
export default {
  data() {
    return {
      baseURL,
      headers: {
        Authorization: `Bearer ${this.$store.state.token}`,
      },
      accountType: 0, //0表示自主注册  1表示企业微信
      form: {
        idCard: "",
      },
      rules: {
        idCard: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
      },
      flag1: true,
      flag2: true,
      type: 1,
      formA: {
        idCard: "",
        teacherType: "",
      },
      imageUrl: "",
      teacherTypeList: [
        {
          value: 1,
          label: "内部讲师",
        },
        {
          value: 2,
          label: "外部讲师",
        },
      ],
      user: this.$store.state.userInfo,
      userInfo: {},
      persionName: this.$store.state.userInfo.persionName,
      avaUrl: "",
      positionDisabled: false,
    };
  },

  created() {
    this.userInfo = JSON.parse(JSON.stringify(this.user));
    // console.log(this.userInfo, "userInfo");
  },

  mounted() {},

  methods: {
    handleAvatarSuccess(res) {
      // this.userInfo.avatar = res.url;
      this.avaUrl = res.url;
    },

    //编辑个人信息
    editUserInfo() {
      // console.log(this.userInfo);
      let userInfo = {};
      userInfo.persionName = this.persionName;
      userInfo.avatar = this.avaUrl;
      this.$http
        .put(
          "/server/portal/personCenter/updateUserDetails",
          Object.assign({}, this.userInfo, userInfo)
        )
        .then(async (res) => {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          const user = await this.$http.get(
            "server/portal/personCenter/getUserDetails"
          );
          await this.$store.dispatch("setUserInfo", user.data);
          this.userInfo = this.$store.state.userInfo;
          this.user = this.$store.state.userInfo;
          this.type = 1;
          this.$forceUpdate();
        });
    },

    inputLimit(val) {
      // 正则匹配非中英文及数字的字符
      let reg = /[^\u4e00-\u9fa5a-zA-Z0-9]/;
      // 查找是否有非中英文及数字的字符
      // 没有则返回-1，有则返回对应位置
      let n = val.search(reg);
      if (n !== -1) {
        // 由于每次触发，通常只有最后一个字符是有可能异常的
        // 所以这里是直接截取异常字符前面的部分
        this.userInfo.position = val.slice(0, n);
      }
    },

    onBack() {
      this.userInfo = JSON.parse(JSON.stringify(this.user));
      this.type = 1;
    },

    // 编辑讲师信息
    userAction() {
      this.type = 2;
      if (this.userInfo.accountType === 1) this.positionDisabled = true;
      if (this.userInfo.accountType === 0 && this.userInfo.position) {
        this.positionDisabled = true;
      }
      this.avaUrl = JSON.parse(JSON.stringify(this.userInfo.avatar));
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  background-color: #f1f1f1;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 63px;
  height: 63px;
  line-height: 63px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
